import {
	getSessionId,
} from 'utils/logrocket';
import './Support.scss'
import {
	ModalWithFooter,
} from '../modal';
import {
	useState,
} from 'react';
import {
	useFeedbackService,
} from 'services/useFeedback';
import Checkbox from '../checkbox/Checkbox';
import {
	Input,
} from '../form';

export const Support = (): JSX.Element => {
	const sessionId = getSessionId();
	const {
		isPosting,
		send: sendFeedback,
		phoneNumber,
		setPhoneNumber,
	} = useFeedbackService();

	const [showReportModal, setShowReportModal] = useState(false);
	const [reportText, setReportText] = useState('');
	const [allowContact, setAllowContact] = useState(true);

	return (
		<>
			<ModalWithFooter
				dataTestId="feedback-modal"
				buttonTextConfirm="Send"
				buttonTextClose="Avbryt"
				show={showReportModal}
				title="Melde feil"
				isSubmitDisabled={isPosting}
				doNotCloseOnConfirm
				onConfirmation={(closeModal) => {
					sendFeedback(reportText, allowContact)
						.then(() => {
							setReportText('');
							setAllowContact(true);
							closeModal();
						})
						.catch(() => {
						});
				}}
				onClose={() =>
					setShowReportModal(false)
				}
			>
				<p>Så leit at du opplever problemer!</p>
				<p>Dersom du kan skrive noen få ord om hva som oppleves, vil vi se på saken så snart som mulig.</p>
				<textarea
					className="reportText"
					value={reportText}
					maxLength={1_000}
					onChange={change => {
						const text = change.currentTarget.value;
						if (text.length > 1_000) {
							setReportText(text.substring(0, 1_000));
							return;
						}
						setReportText(change.currentTarget.value)
					}}
				/>
				<div>
					<Checkbox
						label="Dere kan ta kontakt med meg på telefon"
						checked={allowContact}
						onChange={value => setAllowContact(value)}
					/>
					{allowContact ?
						<Input<string>
							rowValue={phoneNumber}
							onChange={value => setPhoneNumber(value)}
							placeholderText="Telefonnummer"
						/> : null}
				</div>
			</ModalWithFooter>
			<div className="supportId">
				<small>Support ID:</small>
				<small>{sessionId}</small>
				<br />
				<button
					onClick={() => setShowReportModal(true)}
					className="btn btn-outline-danger mt-2"
				>
					Problemer?
					<br />
					Rapportér feil her!
				</button>
			</div>
		</>
	);
}